var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6667 18.3333H11.8917L17.9467 11.0667C18.5367 10.36 18.44 9.30834 17.7333 8.72001C17.025 8.13001 15.975 8.22668 15.3867 8.93334L7.05334 18.9333C6.98834 19.0117 6.95501 19.1033 6.90667 19.19C6.86667 19.26 6.81834 19.32 6.78834 19.3967C6.71334 19.5883 6.66834 19.79 6.66834 19.9933C6.66834 19.995 6.66667 19.9983 6.66667 20C6.66667 20.0017 6.66834 20.005 6.66834 20.0067C6.66834 20.21 6.71334 20.4117 6.78834 20.6033C6.81834 20.68 6.86667 20.74 6.90667 20.81C6.95501 20.8967 6.98834 20.9883 7.05334 21.0667L15.3867 31.0667C15.7167 31.4617 16.19 31.6667 16.6667 31.6667C17.0433 31.6667 17.4217 31.54 17.7333 31.28C18.44 30.6917 18.5367 29.64 17.9467 28.9333L11.8917 21.6667H31.6667C32.5867 21.6667 33.3333 20.92 33.3333 20C33.3333 19.08 32.5867 18.3333 31.6667 18.3333Z",
    fill: "#8F88A4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_860_7884",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 8,
    width: 28,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6667 18.3333H11.8917L17.9467 11.0667C18.5367 10.36 18.44 9.30834 17.7333 8.72001C17.025 8.13001 15.975 8.22668 15.3867 8.93334L7.05334 18.9333C6.98834 19.0117 6.95501 19.1033 6.90667 19.19C6.86667 19.26 6.81834 19.32 6.78834 19.3967C6.71334 19.5883 6.66834 19.79 6.66834 19.9933C6.66834 19.995 6.66667 19.9983 6.66667 20C6.66667 20.0017 6.66834 20.005 6.66834 20.0067C6.66834 20.21 6.71334 20.4117 6.78834 20.6033C6.81834 20.68 6.86667 20.74 6.90667 20.81C6.95501 20.8967 6.98834 20.9883 7.05334 21.0667L15.3867 31.0667C15.7167 31.4617 16.19 31.6667 16.6667 31.6667C17.0433 31.6667 17.4217 31.54 17.7333 31.28C18.44 30.6917 18.5367 29.64 17.9467 28.9333L11.8917 21.6667H31.6667C32.5867 21.6667 33.3333 20.92 33.3333 20C33.3333 19.08 32.5867 18.3333 31.6667 18.3333Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_860_7884)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#8F88A4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow-back.22e8fe6ee118f2a7b4d0bc4201bc4527.svg";
export { ForwardRef as ReactComponent };